"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addRecordingSchema = exports.addRecordingFormFields = void 0;
const zod_1 = require("zod");
const error_messages_1 = require("@Const/error-messages");
const error_messages_2 = require("@Entities/schemas/work/error-messages");
const work_entities_fields_validators_1 = require("@App/helpers/work-entities-fields-validators");
const form_field_types_1 = require("@App/enum/form-field-types");
const populate_schema_1 = __importDefault(require("@App/forms/v2/helpers/populate-schema"));
const titleKey = 'title';
const artistNameKey = 'artistName';
const isrcKey = 'isrc';
const durationKey = 'duration';
const labelKey = 'label';
const releaseDateKey = 'releaseDate';
const addRecordingSchema = zod_1.z.object({
    [titleKey]: zod_1.z
        .string({
        required_error: error_messages_1.REQUIRED_MESSAGE,
        invalid_type_error: error_messages_1.REQUIRED_MESSAGE,
    })
        .max(200, (0, error_messages_2.stringSizeMaxMessage)('Title', 200))
        .min(1, error_messages_1.REQUIRED_MESSAGE),
    [artistNameKey]: zod_1.z
        .string({
        required_error: error_messages_1.REQUIRED_MESSAGE,
        invalid_type_error: error_messages_1.REQUIRED_MESSAGE,
    })
        .max(60, (0, error_messages_2.stringSizeMaxMessage)('Artist Name', 60))
        .min(1, error_messages_1.REQUIRED_MESSAGE),
    [isrcKey]: zod_1.z
        .string()
        .refine((isrcVal) => !(0, work_entities_fields_validators_1.isrcInvalidCheck)(isrcVal), error_messages_1.IS_ISRC_MESSGAE)
        .optional(),
    [durationKey]: zod_1.z
        .string()
        .refine((durationVal) => !durationVal || durationVal.match(/^[0-9]{2}[:]{1}[0-9]{2}$/), error_messages_1.IS_DURATION_MESSAGE)
        .optional(),
    [labelKey]: zod_1.z.string().max(60, (0, error_messages_2.stringSizeMaxMessage)('Label', 60)).optional(),
    [releaseDateKey]: zod_1.z.date().optional(),
});
exports.addRecordingSchema = addRecordingSchema;
const addRecordingFormFieldsNoSchema = {
    [titleKey]: {
        name: titleKey,
        label: 'Recording Title',
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    [artistNameKey]: {
        name: artistNameKey,
        label: 'Recording Artist Name',
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    [isrcKey]: {
        name: isrcKey,
        label: 'ISRC',
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    [labelKey]: {
        name: labelKey,
        label: 'Label',
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    [durationKey]: {
        name: durationKey,
        label: 'Duration',
        type: form_field_types_1.FormFieldTypes.TEXT,
    },
    [releaseDateKey]: {
        name: releaseDateKey,
        label: 'Release Date',
        type: form_field_types_1.FormFieldTypes.DATEPICKER,
    },
};
const addRecordingFormFields = (0, populate_schema_1.default)(addRecordingFormFieldsNoSchema, addRecordingSchema);
exports.addRecordingFormFields = addRecordingFormFields;
